module.exports = "<div class=\"spinner animation-start\">\n    <span class=\"circle delay-1 size-2\"></span>\n    <span class=\"circle delay-2 size-4\"></span>\n    <span class=\"circle delay-3 size-6\"></span>\n    <span class=\"circle delay-4 size-7\"></span>\n    <span class=\"circle delay-5 size-7\"></span>\n    <span class=\"circle delay-6 size-6\"></span>\n    <span class=\"circle delay-7 size-4\"></span>\n    <span class=\"circle delay-8 size-2\"></span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/master-shared/master-spinner/master-spinner.component.html
// module id = ./src/app/master-shared/master-spinner/master-spinner.component.html
// module chunks = main